import { render, staticRenderFns } from "./standardNew.vue?vue&type=template&id=c3305170&scoped=true&"
import script from "./standardNew.vue?vue&type=script&lang=js&"
export * from "./standardNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3305170",
  null
  
)

export default component.exports